<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Constantes initiales
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{
                    "Tolérance d'arrivée" + error.datas.limitLateArrival + " - Tolérance de départ " +
                    error.datas.limitEarlyDeparture + " - Inclusion inférieure " +
                    error.datas.limitInfOutsideShift + " - Inclusion supérieure " +
                    error.datas.limitSupOutsideShift + " - Hauteur jours à afficher " +
                    error.datas.heightDays + " -> " + error.message
                  }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-btn :disabled="!showResetButton || disableMainBtn" @click="onResetTestData" block class="custom-btn white--text"
                     color="#F44336"
                     height="45px" large v-if="showResetButton">
                <v-icon class="mr-1">mdi-database-remove</v-icon>
                <span>Reset Test Data</span>
              </v-btn>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export Constantes</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "Constantes",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      lastHighlitedRow: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      toObject: [],
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        trimRows: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        comment: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders:
            ["Id", "Tolérance d'arrivée (minute)", "Tolérance de départ (minute)", "Inclusion inférieure (heure)", "Inclusion supérieure (heure)", "Repos entre 2 shifts (heure)",
              "Superposition de shifts", "Hauteur jours", "Nbr plats anonymes"],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Tolérance d'arrivée (minute)", width: "300px"},
          {title: "Tolérance de départ (minute)", width: "300px"},
          {title: "Inclusion inférieure (heure)", width: "300px"},
          {title: "Inclusion supérieure (heure)", width: "300px"},
          {title: "Repos entre 2 shifts (heure)", width: "300px"},
          {title: "Superposition de shifts", width: "300px", type: "checkbox"},
          {title: "Hauteur jours", width: "180px"},
          {title: "Nbr plats anonymes", width: "300px"},
        ]
      }
    }
  },

  computed: {
    showResetButton() {
      const baseUrl = this.$store.getters.user.baseUrl;
      return baseUrl === "https://tests.eyone.cartaware.cartalink.com" || baseUrl.includes("localhost");
    }
  },

  created() {
    this.getData()
  },

  methods: {
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/constantes/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["limitLateArrival"],
                item["limitEarlyDeparture"],
                item["limitInfOutsideShift"],
                item["limitSupOutsideShift"],
                item["restTimeBetweenShifts"],
                item["shiftsOverlapped"],
                item["heightDays"],
                item["nbrPlatAnonymes"]
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    close() {
      this.dialog = false;
      this.file = "";
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    onResetTestData() {
      let message = {
        title: 'Confirmation de réinitialisation',
        body: 'Êtes-vous sûr de vouloir réinitialiser toutes les données de test ? Cette action est irréversible et supprimera toutes les transactions, recharges et données de portefeuille.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true
            apiClient
                .post(`${this.$store.getters.user.baseUrl}/admin/reset-test-data`)
                .then(response => {
                  this.loading = false
                  dialog.close();

                  if (response.data.status === 200) {
                    this.color = "#009688"
                    this.text = response.data.message;
                    this.showAlert('info')
                  } else {
                    this.color = "#F44336"
                    this.text = response.data.message;
                    this.showAlert('warning')
                  }
                })
                .catch((err) => {
                  this.loading = false
                  dialog.close();
                  this.color = "#F44336"
                  this.text = "Erreur lors de la réinitialisation des données de test.";
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            // User cancelled
          });
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du paramètre.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              let str = "Reconfirmez l'envoi des nouveaux paramètres au serveur.";
              this.loading = true
              let obj = {}
              let newObj = {}

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              if ((obj[1] < 0) || (obj[2] < 0) || (obj[3] < 0) || (obj[4] < 0) || (obj[5] < 0) || (obj[7] < 0) || (obj[8] < 0)) {
                this.alert = true
                this.color = "#F44336"
                this.text = "Aucune valeur ne doit être négative. Merci de corriger."

                let myData = this.$refs.hotTable.hotInstance.getData()
                myData[changes[0][0]][changes[0][1]] = changes[0][2]
                this.$refs.hotTable.hotInstance.loadData(myData)
                this.showAlert('warning')
                this.loading = false
                dialog.close();
                return;
              }

              if (changes[0][1] === 6) {
                if (changes[0][3] === true) {
                  str = `Attention : Le délai de repos entre 2 shifts sera mis à 0 pour pouvoir activer la superposition de shifts.`
                } else {
                  str = `Attention : N'oubliez pas de repositionner le délai de repos entre 2 shifts qui est à 0 actuellement.`
                }
              }

              if (changes[0][1] === 5) {
                if (changes[0][3] !== 0) {
                  str = `Attention :  la superposition de shifts sera désactivée si le délai de repos entre 2 shifts est différent de 0.`
                } else {
                  str = `Attention : N'oubliez pas de réactiver la superposition de shifts vu que le délai de repos entre 2 shifts est à 0.`
                }
              }

              let message = {
                title: 'Fenêtre de confirmation',
                body: `${str}`
              };

              dialog.close();
              this.$dialog
                  .confirm(message)
                  .then(dialog => {
                    newObj = {
                      "id": obj[0],
                      "limitLateArrival": obj[1],
                      "limitEarlyDeparture": obj[2],
                      "limitInfOutsideShift": obj[3],
                      "limitSupOutsideShift": obj[4],
                      "restTimeBetweenShifts": obj[5],
                      "shiftsOverlapped": obj[6],
                      "heightDays": obj[7],
                      "nbrPlatAnonymes": obj[8]
                    }
                    apiClient
                        .post(
                            `${this.$store.getters.user.baseUrl}/account/constantes/` +
                            sessionStorage.getItem("userId"),
                            newObj
                        )
                        .then(res => {
                          dialog.close();
                          this.loading = false
                          this.dialog = false;
                          if (res.data.status === 200) {
                            this.color = "#009688"
                            this.text = res.data.message;
                            this.showAlert('info')
                            this.refresh()
                          } else {
                            this.alert = true
                            this.color = "#F44336"
                            this.text = res.data.message;

                            let myData = this.$refs.hotTable.hotInstance.getData()
                            myData[changes[0][0]][changes[0][1]] = changes[0][2]
                            this.$refs.hotTable.hotInstance.loadData(myData)
                            this.showAlert('warning')
                          }
                        })
                        .catch((err) => {
                          dialog.close();
                          this.dialog = false;
                          let myData = this.$refs.hotTable.hotInstance.getData()
                          myData[changes[0][0]][changes[0][1]] = changes[0][2]
                          this.$refs.hotTable.hotInstance.loadData(myData)

                          this.alert = true
                          this.color = "#F44336"
                          this.text = err.data.message;
                          this.loading = false
                          this.showAlert('warning')
                        });
                  })
                  .catch(() => {
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)
                  });
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },
    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Constantes") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Constantes.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.pre-formatted {
  white-space: pre;
}
</style>
 
